var exports = {
  "kL": "xfd349460--374981--container",
  "wx": "xfd349460--374981--header",
  "Qs": "xfd349460--374981--content",
  "AS": "xfd349460--374981--item",
  "DD": "xfd349460--374981--title",
};

module.exports = exports;
